import { render, staticRenderFns } from "./VisuwellUser.vue?vue&type=template&id=37f7bcd7&scoped=true&"
import script from "./VisuwellUser.vue?vue&type=script&lang=js&"
export * from "./VisuwellUser.vue?vue&type=script&lang=js&"
import style0 from "./VisuwellUser.vue?vue&type=style&index=0&id=37f7bcd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f7bcd7",
  null
  
)

export default component.exports